var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"historyVisew"},[(_vm.serverStatus == true)?_c('history',{key:_vm.componentKey}):_vm._e(),(_vm.serverStatus != true)?_c('noConnect'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }